export enum FORTUNE_WHEEL_PRIZE_ID {
  POINT1 = 'point1',
  POINT2 = 'point2',
  POINT3 = 'point3',
  POINT4 = 'point4',
  SPIN1 = 'spin1',
  SPIN3 = 'spin3',
  SPIN5 = 'spin5',
  SPIN10 = 'spin10',
  USDT5 = 'usdt5',
  USDT10 = 'usdt10',
  USDT50 = 'usdt50',
  USDT100 = 'usdt100',
  USDT500 = 'usdt500',

  GOLD_FEATHER_10 = 'gold_feather_10',
  SPIN_GOLDEN1 = 'spin_golden1',
  TICKET = 'ticket',
  // Gotcha cards
  GACHA_BOX_CARD1 = 'gacha_box_card1',
  GACHA_BOX_CARD2 = 'gacha_box_card2',
  GACHA_BOX_CARD3 = 'gacha_box_card3',
  GACHA_BOX_CARD4 = 'gacha_box_card4',
  GACHA_BOX_CARD5 = 'gacha_box_card5',
  // Prize box items
  PRIZE_BOX_DOUBLE_PROFIT_0_5 = 'prize_box_double_profit_0_5',
  PRIZE_BOX_DOUBLE_PROFIT_3 = 'prize_box_double_profit_3',
  PRIZE_BOX_OFFLINE_PROFIT_0_5 = 'prize_box_offline_profit_0_5',
  PRIZE_BOX_OFFLINE_PROFIT_1 = 'prize_box_offline_profit_1',
  PRIZE_BOX_OFFLINE_PROFIT_2 = 'prize_box_offline_profit_2',
  PRIZE_BOX_OFFLINE_PROFIT_5 = 'prize_box_offline_profit_5',
  PRIZE_BOX_OFFLINE_PROFIT_6 = 'prize_box_offline_profit_6',
  PRIZE_BOX_OFFLINE_PROFIT_8 = 'prize_box_offline_profit_8',
  PRIZE_BOX_OFFLINE_PROFIT_12 = 'prize_box_offline_profit_12',
  PRIZE_BOX_OFFLINE_PROFIT_24 = 'prize_box_offline_profit_24',
  PRIZE_BOX_GOLDEN_COIN_1 = 'prize_box_golden_coin_1',
  PRIZE_BOX_GOLDEN_COIN_3 = 'prize_box_golden_coin_3',
  PRIZE_BOX_SPIN_3 = 'prize_box_spin_3',
  PRIZE_BOX_SPIN_5 = 'prize_box_spin_5',
  PRIZE_BOX_SPIN_10 = 'prize_box_spin_10',
  PRIZE_BOX_TICKET_1 = 'prize_box_ticket_1',
  PRIZE_BOX_GOLD_FEATHER_50 = 'prize_box_golden_feather_50',
  PRIZE_BOX_GOLD_FEATHER_100 = 'prize_box_golden_feather_100',

  // Golden only
  GOLDEN_USDT25 = 'golden_usdt25',
  GOLDEN_USDT50 = 'golden_usdt50',
  GOLDEN_USDT100 = 'golden_usdt100',
  GOLDEN_USDT500 = 'golden_usdt500',
  GOLDEN_USDT1000 = 'golden_usdt1000',
  GOLDEN_USDT2000 = 'golden_usdt2000',
  GOLDEN_USDT5000 = 'golden_usdt5000',
  GOLDEN_SPIN5 = 'golden_spin5',
  GOLDEN_SPIN10 = 'golden_spin10',
  GOLDEN_SPIN25 = 'golden_spin25',
  GOLDEN_SPIN50 = 'golden_spin50',
}

export enum FORTUNE_WHEEL_PRIZE_TYPE {
  SPIN = 'spin',
  SPIN_GOLDEN = 'spin_golden',
  POINTS = 'points',
  FREE_UPGRADE = 'free_upgrade',
  USDT = 'usdt',
  TICKET = 'ticket',
  GACHA_BOX_ITEM = 'gacha_box_item',
  PRIZE_BOX_ITEM = 'prize_box_item',
  GOLD_FEATHER = 'gold_feather',
}

export enum FORTUNE_WHEEL_PRIZE_SUBTYPE {
  DOUBLE_PROFIT = 'double_profit',
  OFFLINE_PROFIT = 'offline_profit',
  GOLDEN_COIN = 'golden_coin',
  SPIN = 'spin',
  TICKET = 'ticket',
  GOLD_FEATHER = 'goldFeather',
}

export type FortuneWheelPrize = {
  id: FORTUNE_WHEEL_PRIZE_ID
  type: FORTUNE_WHEEL_PRIZE_TYPE
  subtype?: FORTUNE_WHEEL_PRIZE_SUBTYPE
  amount: number
}

export type PlayerFortuneWheelState = {
  lastWonPrizes: FORTUNE_WHEEL_PRIZE_ID[],
  usdtCentsBalance: number
  usdtCentsBalanceAllTime: number
  cards: Record<string, { count: number, lastAcquisitionTimestamp: number }>
  totalCentsSpent?: number
  spins: {
    total: number
    available: number
    lastDailyTicketTimestamp: number
    lastSpinDate: string
    streak: number
    maxStreak: number
  },
  withdrawals: {
    timestamp: number,
    amount: number,
    status: string,
    convertedAmount: number,
    convertedTo: 'spin' | 'usdt' | 'star'
  }[]
}
